import type { AttentionItem } from '../core/attention';
import type { Locale } from '../types';
import { chrome, formatDataDate } from '../i18n';
import { icon } from './Icon';

export function AttentionInbox(items: AttentionItem[], locale: Locale): string {
  const c = chrome(locale);
  if (items.length === 0) {
    return `<div class="attention-empty">${icon('check-circle-2')} ${c.attentionEmpty}</div>`;
  }
  const rows = items
    .map(
      (it) => `
    <a class="attn-item ${it.severity}" href="#/${it.href}" style="--accent:${it.accent}">
      <span class="attn-ic">${icon(it.icon)}</span>
      <div class="attn-body">
        <div class="attn-reason">${it.reason}</div>
        <div class="attn-title">${it.title}</div>
        <div class="attn-detail">${it.detail}</div>
        <div class="attn-meta">
          ${it.owner ? `<span>${icon('user', 'icon icon-xs')} ${it.owner}</span>` : ''}
          ${it.due ? `<span>${icon('calendar', 'icon icon-xs')} ${formatDataDate(locale, it.due)}</span>` : ''}
        </div>
      </div>
      <span class="attn-go">${locale === 'ar' ? '←' : '→'}</span>
    </a>`,
    )
    .join('');
  return `<div class="attn-list">${rows}</div>`;
}
